module.exports = __webpack_public_path__ + "img/sepak.fc527e2d.png";